import './style.scss';
import { CreateTeamSteps } from '../Components/CreateTeamSteps/CreateTeamSteps';
import {
  Button,
  SearchBar,
  SearchIcon,
  PopoverItem,
  Loading,
} from '@trufla-technology/trumarket-react-design-system';
import { UserCard } from './Components/UserCard/UserCard';
import { AssignUserToTeam } from './Components/AssignUserToTeam/index';
import { useListUsers } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { useHistory, useParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { debounce } from 'lodash';
import { EditTeamSteps } from '../Components/EditTeamSteps/EditTeamSteps';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';

export interface IProps {
  mode?: string;
}
interface IParamTypes {
  teamKey: string;
}

export const TeamUsers = (props: IProps) => {
  const { isPermitted } = useAuthContext();
  const history = useHistory();
  const { teamKey } = useParams<IParamTypes>();
  const { data, loading, handleFilter, get } = useListUsers({
    filter: { teamKeys: [teamKey] },
    paginate: { offset: 0, limit: 100 },
  });

  const debouncedSearch = useRef(
    debounce(async (searchValue) => {
      await handleFilter({
        fullName: searchValue.length > 0 ? searchValue : undefined,
      });
    }, 600),
  ).current;
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);
  const handleNext = () => {
    history.push('/configurations/teams/');
  };

  useEffect(() => {
    if (props.mode !== 'edit') {
      history.replace({
        search: 'assign=user-to-team',
        state: teamKey,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="teams-users">
      <form onSubmit={handleNext}>
        {props.mode === 'edit' ? (
          <EditTeamSteps />
        ) : (
          <CreateTeamSteps disableFinish={data?.length === 0} step={4} />
        )}
      </form>
      <div className="users-list">
        <div className="search-sorting-bar">
          <SearchBar
            placeholder="Filter"
            onSearch={(e: string) => {
              debouncedSearch(e);
            }}
            isSecondary
            icon={<SearchIcon fill="var(--tru-gunmetal)" />}
          />
          {isPermitted('assignUsersToTeams') && (
            <div>
              <Button
                htmlType="button"
                type="primary"
                onClick={() => {
                  history.replace({
                    search: 'assign=user-to-team',
                    state: teamKey,
                  });
                }}
              >
                Assign User to Team
              </Button>
              {data && (
                <PopoverItem
                  key={loading ? 0 : 1}
                  match="assign=user-to-team"
                  title="Add Users"
                  onClose={() => history.replace({ search: '' })}
                  showBackArrow={true}
                  component={() => (
                    <AssignUserToTeam
                      getUsers={get}
                      teamKey={teamKey}
                      usersAssigned={data}
                    />
                  )}
                />
              )}
            </div>
          )}
        </div>{' '}
        {loading && <Loading />}
        <div className="users-list-scroll">
          {!loading &&
            data?.map((user) => {
              return (
                <div className="card-w-25" key={user.key}>
                  <UserCard data={user} getUsers={get} />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
